import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CheckoutService } from '../../../services/checkout/checkout.service';
import { environment } from 'src/environments/environment';
import { IdentialertSubSelectionModalComponent } from '../subscription-pages/identialert-sub-selection-modal/identialert-sub-selection-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductType } from 'src/app/interfaces/user';
import { ConfigService } from '../../../services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { MainCardTypes } from 'src/app/interfaces/firstPartyTiles';
import { PetSpeciesFilterableType } from 'src/app/interfaces/pet';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';

@Component({
  selector: 'app-main-plan-card',
  templateUrl: './main-plan-card.component.html',
  styleUrls: ['./main-plan-card.component.scss'],
})
export class MainPlanCardComponent implements OnInit {
  @Input() public content;
  @Input() private user;
  @Input() public petName;
  @Input() public petType;
  @Input() public thereIsOnlyOneCat: boolean;
  @Input() public isOutdoors: boolean;
  @Input() public hideIcon: boolean;
  @Input() public useExternalBuyAction: boolean;
  @Input() public disabledBuyNow: boolean;

  @Output() public buyClicked: EventEmitter<void> = new EventEmitter();
  @Input() public userCurrentProductType: number;
  @Input() public productPlanCard: MainCardTypes;


  public subtitleText: string;
  public backgroundImage: string;
  public isUpgrade: boolean;
  public plan2Route: string;
  public isBrandPetlog: boolean;
  public plan2Title: string;
  public isIndoorOutdoorCatAvailable: boolean;
  public plan2CatImageUrl: string;

  public plan2Name: string;
  public plan2YearlyPrice: string;
  public plan2MonthlyPrice: string;
  public plan3Name: string;
  public plan3Route: string;
  public plan3YearlyPrice: string;
  public plan3MonthlyPrice: string;

  constructor(
    private checkoutService: CheckoutService,
    private _modalService: NgbModal,
    private configService: ConfigService,
    private featureFlagService: FeatureFlagsService,
    private paymentConfigService: PaymentConfigService
  ) {
    this.plan2Route = this.configService.getTextFromKey('2-plan-route');
    this.isBrandPetlog = this.configService.isPetlogBrand();
    this.plan2Title = this.configService.getTextFromKey('2-plan-title');
    this.isIndoorOutdoorCatAvailable = this.featureFlagService.isEnabled('isIndoorOutdoorCatAvailable');
    this.plan2CatImageUrl = this.configService.getTextFromKey('2-plan-cat-image-route');
    this.plan2MonthlyPrice = this.configService.getTextFromKey('2-plan-monthly-price');
    this.plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');

    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ?? this.plan2YearlyPrice;
    this.plan2MonthlyPrice = this.paymentConfigService.getMonthlyDisplayPrice(
      ProductType.Premium,
      this.plan2MonthlyPrice
    );
  }

  ngOnInit(): void {
    this.plan2Title = this.plan2Title.replace('{{petName}}', this.petName);
    this.subtitleText = this.petName ? this.plan2Title : 'Your pet’s lifeline, anytime. <br> Stay prepared and reunite with your pet faster.'
    if (this.thereIsOnlyOneCat && this.isIndoorOutdoorCatAvailable) {
      if (this.isOutdoors) {
        this.subtitleText = `For the intrepid adventurer as well as those who simply enjoy a stroll in the garden, cats who venture outdoors are at risk of being lost or stolen. Bring ${this.petName} home with ${this.plan2Name}.`
      } else {
        this.subtitleText = `Indoor-only cats are uniquely at risk of getting lost or being stolen. Bring ${this.petName} home with ${this.plan2Name}.`;
      }
    }
    if (this.petType === PetSpeciesFilterableType.Dog) {
      this.backgroundImage = 'url(/assets/images/main-plan-card/dogBanner.jpeg';
    } else if (this.petType === PetSpeciesFilterableType.Cat && this.thereIsOnlyOneCat && this.isOutdoors && this.isIndoorOutdoorCatAvailable) {
      this.backgroundImage = 'url(/assets/images/main-plan-card/outdoorcatBanner.jpeg)';
    } else if (this.petType === PetSpeciesFilterableType.Cat && this.thereIsOnlyOneCat && this.isIndoorOutdoorCatAvailable) {
      this.backgroundImage = 'url(/assets/images/main-plan-card/indoorCatBanner.jpeg)';
    } else {
      this.backgroundImage = `url(${this.plan2CatImageUrl})`;
    }

    if (this.user) {
      this.userCurrentProductType = this.user.productType;
    }

    this.isUpgrade = this.userCurrentProductType === ProductType.Basic;
  }

  public onBuyNowClick(): void {
    if (this.useExternalBuyAction) {
      this.buyClicked.emit();
      return;
    }

    if (this.isBrandPetlog) {
      this.buyIdentialertSubs();
    } else {
      this.buyIdentiAlertSubscription();
    }
  }

  public buyIdentialertSubs() {
    this.checkoutService
    .checkout(
      [environment.stripePlans.identiAlertAnnual],
      { isUpgrade: this.isUpgrade }
    ).subscribe({
      next() {},
      error() {}
    }
    );
  }

  public buyIdentiAlertSubscription() {
    if (!this.plan2MonthlyPrice) {
      this.buyIdentialertSubs();
      return;
    }
    const identialertSubSelectionModalRef = this._modalService.open(
      IdentialertSubSelectionModalComponent,
      {
        backdrop: 'static',
        centered: true,
        size: 'md',
      }
    );
    identialertSubSelectionModalRef.componentInstance.modalRef = identialertSubSelectionModalRef;
    identialertSubSelectionModalRef.componentInstance.isUpgrade = this.isUpgrade;
  }
}
